export default __webpack_public_path__ + "static/media/slider-why-laptop-image1.548f2157.jpg";